import { Flex } from 'vcc-ui';

import CookieTemplate from '@collab/templates/CookieTemplate';
import { seo } from '@collab/templates/CookieTemplate/cookie.content';

import PageSeo from 'libs/seo/PageSeo';

const Cookies = () => (
  <Flex>
    <PageSeo {...seo} />
    <CookieTemplate
      cookies={{
        strictlyNecessary: [
          {
            host: 'design.volvocars.com',
            cookies: [
              'TOKEN (1 days)',
              'adsso_ak_token (Session)',
              'NONCE (Session)',
            ],
          },
        ],
      }}
    />
  </Flex>
);

export default Cookies;
